import { IconArrowCorners, IconXCircle } from '@veneer/core';
import React from 'react';
import {
  CancelHPInstantInkButtonClicked,
  CancelHPAllInButtonClicked,
  ChangeYourInstantInkPlanButtonClicked,
  ChangeYourAllInPlanButtonClicked
} from 'src/utils/analytics';
import { SubscriptionsWarningState } from 'src/utils/enums';
import { URLS } from 'src/utils/urls';
import { SubscriptionsCardProps } from '../SubscriptionsCard/types';
import getSubscriptionWarningState from 'src/helpers/getSubscriptionWarningState';
import { useDependencyManagerContext } from 'src/contexts/dependencyManager';
import { ROW_TYPE, SubscriptionType } from '@uma/react-commons/dist/index';
import { CardRowProps } from '@uma/react-commons/dist/components/Card/CardWrapper/CardRow';
import { StyledCard } from '../../styles/styles';

export const MoreOptions = ({
  subscription
}: SubscriptionsCardProps): React.JSX.Element => {
  const { translate } = useDependencyManagerContext();
  const subscriptionState = getSubscriptionWarningState(
    subscription?.state,
    subscription?.type
  );

  const rows = [] as CardRowProps[];
  const isInstantInk = subscription?.type === SubscriptionType.INSTANT_INK;

  rows.push({
    index: 0,
    icon: <IconArrowCorners />,
    type: ROW_TYPE.EXTERNAL,
    content: translate(
      'subscriptions.changeYourPlan',
      'Change your plan'
    ) as string,
    link: {
      url: isInstantInk ? URLS.ChangeYourPlanPrint : URLS.ChangeYourPlanAllIn,
      dataTestId: 'ChangeYourPlanButton'
    },
    analyticsEvent: isInstantInk
      ? ChangeYourInstantInkPlanButtonClicked
      : ChangeYourAllInPlanButtonClicked
  });

  const canCancel = subscriptionState !== SubscriptionsWarningState.INACTIVE;

  if (canCancel) {
    const cancelHpAllInUrl = subscription?.resourceId
      ? `${URLS.CancelHPAllIn}/${subscription.resourceId}`
      : URLS.ChangeYourPlanAllIn;

    rows.push({
      index: 1,
      icon: <IconXCircle />,
      type: ROW_TYPE.EXTERNAL,
      content: `${translate('subscriptions.cancelYour', 'Cancel your')} ${
        isInstantInk
          ? translate('common.instantInk', 'HP Instant Ink')
          : translate('common.allInPrintPlan', 'HP All-In Plan')
      }`,
      link: {
        url: isInstantInk ? URLS.CancelHPInstantInk : cancelHpAllInUrl,
        dataTestId: 'CancelPlanButton'
      },
      analyticsEvent: isInstantInk
        ? CancelHPInstantInkButtonClicked
        : CancelHPAllInButtonClicked(cancelHpAllInUrl)
    });
  }

  return (
    <StyledCard
      title={{
        content: translate('common.moreOptions', 'More options') as string
      }}
      rows={rows}
      data-testid="more-options-section"
    />
  );
};
